import type { PlayerView } from '@sh/shared'
import { Veil } from './Veil.js'

/**
 * Your own role, re-readable behind the same press-and-hold it was dealt
 * behind. People genuinely forget which of three fascists they are.
 *
 * It sits at the foot of the seat list rather than pinned to the bottom of the
 * window. Pinned, it was a second dock competing with the one holding whatever
 * the game is actually asking of you, and the two spent their time measuring
 * each other to keep off each other's toes. In the list it is a row about a
 * player among the rows about players - which is both where it belongs and
 * where somebody already looking down the table thinks to find it.
 *
 * Your own role and nothing else. Who the other fascists are was shown once, at
 * the reveal, and the server stops sending it the moment that phase ends: there
 * is nothing here to re-open because there is nothing left to show.
 */
export function SecretDrawer({ view }: { view: PlayerView }) {
  const you = view.you
  if (!you?.role) return null

  return (
    <div className="drawer">
      <Veil
        label="Hold to check your secret"
        tone={you.party === 'liberal' ? 'liberal' : 'fascist'}
        frame="text"
        testId="secret-drawer"
      >
        <span className="drawer__role">
          You are <strong>{you.role === 'hitler' ? 'Hitler' : you.role}</strong>
        </span>
        {you.party === 'fascist' && (
          <span className="drawer__team">Your team is yours to remember.</span>
        )}
      </Veil>
    </div>
  )
}
